import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../../shared-components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-payments-gateway-resume-card',
  templateUrl: './payments-gateway-resume-card.component.html',
  styleUrls: ['./payments-gateway-resume-card.component.scss']
})
export class PaymentsGatewayResumeCardComponent implements OnInit, OnDestroy {

  @Input() gateway;
  @Input() viewDisposition;
  updateGatewayStatusSubscription: Subscription;
  deleteGatewaySubscription: Subscription;

  constructor(private snackbarService: SnackBarService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private paymentsService: PaymentsService,
              public dialog: MatDialog) { }

  ngOnInit() { }

  public toggleStatus() {
    this.updateGatewayStatusSubscription = this.paymentsService.updateGatewayStatus(!this.gateway.Active, this.gateway.InternalId).subscribe(
      (res) => {
        this.paymentsService.refreshGateways();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../gateway', this.gateway.InternalId], { relativeTo: this.activatedRoute.parent });
    }
  }

  public deleteGateway() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['gateways-page.delete gateway', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteGatewaySubscription = this.paymentsService.deleteGateway(this.gateway.InternalId).subscribe(
          (res) => {
            this.paymentsService.refreshGateways();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.deleteGatewaySubscription) { this.deleteGatewaySubscription.unsubscribe(); }
  }
}
